import React from "react";
import { Dialog, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Full-size preview for a single evidence item. Images render as-is;
 * videos get native controls and autoplay once opened.
 */
const MediaPreview = ({ open, onClose, type, src }) => {
  if (!src) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { backgroundColor: "#000", boxShadow: "none", overflow: "visible" },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: -14,
          right: -14,
          color: "#fff",
          backgroundColor: "rgba(0,0,0,0.7)",
          zIndex: 1,
          "&:hover": { backgroundColor: "rgba(0,0,0,0.9)" },
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 320,
          p: 0,
        }}
      >
        {type === "video" ? (
          <video
            src={src}
            controls
            autoPlay
            style={{ width: "100%", maxHeight: "80vh" }}
          />
        ) : (
          <img
            src={src}
            alt="Evidence preview"
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
              display: "block",
              margin: "0 auto",
            }}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default MediaPreview;
